<template>
  <div>
    <app-history
      @clicked="
        showDialog = true;
        currentRole = initRole;
        currentCode = '';
        currentFard = '';
        isEdit = false;
      "
      title="افزودن فرد"
    />

    <div>
      <v-data-table
        :items="roles"
        :headers="rolesHeaders"
        class="elevation-1 rounded"
        :disable-pagination="true"
        :hide-default-footer="true"
        :no-data-text="tableText"
        :header-props="$store.getters.headerProps"
      >
        <template v-slot:[`item.isActive`]="{ item }">
          {{ item.isActive ? "بله" : "خیر" }}
        </template>
        <template v-slot:[`item.role`]="{ item }">
          {{ item.role == 1 ? "مدیر" : item.role == 2 ? "حسابدار" : "آشپز" }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn class="dialogButton" rounded @click="editItem(item)"
            >ویرایش</v-btn
          >
          <v-btn class="dialogButton" rounded @click="removeItem(item)"
            >حذف</v-btn
          >
        </template>
      </v-data-table>
    </div>
    <v-dialog v-model="showDialog" content-class="myDialog">
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4">
          {{ isEdit ? "نام فرد" : "انتخاب فرد" }}
        </v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-text-field
            v-if="!isEdit"
            v-model="currentCode"
            maxlength="12"
            :oninput="onInput"
            type="number"
          ></v-text-field>
          <span> {{ currentRole.userName }}</span>
        </v-col>
      </v-row>
      <v-row align="center" v-if="!isEdit">
        <v-col class="d-flex" cols="12" sm="4"> </v-col>
        <v-col class="d-flex fardName" cols="12" sm="8">
          {{ currentFard }}
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4"> نقش </v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-select
            :items="roleTypes"
            item-text="text"
            item-value="value"
            v-model="currentRole.role"
          ></v-select>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="10"> فعال </v-col>
        <v-col class="d-flex ltr" cols="2">
          <v-switch v-model="currentRole.isActive"></v-switch>
        </v-col>
      </v-row>

      <v-row class="ltr">
        <v-btn
          color="green white--text"
          class="dialogButton"
          rounded
          @click="applyRequest"
          :disabled="apiRunning"
        >
          ذخیره
        </v-btn>
        <v-btn
          class="dialogButton"
          rounded
          @click="
            showDialog = false;
            isEdit = false;
          "
        >
          انصراف
        </v-btn>
      </v-row>
    </v-dialog>
    <app-dialog @close="onCloseDialog"></app-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import HistoryButton from "@/components/HistoryButton";
import Dialog from "@/components/Dialog";
import { GetAllUserRoles, SaveRole, DeleteRole } from "@/api/roles";
import { FindUserByCode } from "@/api/user";

export default {
  components: {
    appHistory: HistoryButton,
    appDialog: Dialog,
  },
  data() {
    return {
      showDialog: false,
      roles: [],
      roleTypes: [
        { value: 1, text: "مدیر" },
        { value: 2, text: "حسابدار" },
        { value: 3, text: "آشپز" },
      ],
      currentRole: {},
      currentCode: "",
      initRole: {
        fardId: 0,
        role: 1,
        isActive: true,
        id: "0",
      },
      currentFard: "",
      isEdit: false,

      rolesHeaders: [
        {
          text: "شناسه",
          value: "id",
          width: "10%",
        },
        {
          text: "نام فرد",
          value: "userName",
          width: "20%",
          sortable: false,
        },

        {
          text: "نقش",
          value: "role",
          width: "10%",
        },
        {
          text: "فعال",
          value: "isActive",
          width: "10",
        },

        { text: "", value: "actions", sortable: false, align: "end" },
      ],
    };
  },
  created() {
    this.currentRole = this.initRole;
    if (this.currentBranch) this.GetAllUserRoles();
  },
  computed: {
    tableText() {
      return this.$store.getters.tableText;
    },
    apiRunning() {
      return this.$store.getters.apiRunning;
    },
    currentBranch() {
      return this.$store.getters.currentBranch;
    },
    onInput() {
      return "this.value=this.value.slice(0,this.maxLength)";
    },
  },
  watch: {
    currentCode(value) {
      if (value.length == 10 || value.length == 12) {
        this.FindUser();
      } else {
        this.currentFard = "";
      }
    },
  },
  methods: {
    /**
     * expand khorooj
     */
    GetAllUserRoles() {
      this.$store.commit("SET_TABLE_TEXT", true);
      return new Promise((resolve, reject) => {
        GetAllUserRoles(this.currentBranch.id)
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            this.roles = response.data.items;

            this.$store.commit("SET_TABLE_TEXT", false);

            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    FindUser() {
      return new Promise((resolve, reject) => {
        FindUserByCode(this.currentCode)
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            const data = response.data.data;
            this.currentRole.fardId = data.fardID;
            this.currentFard =
              data.fardID != 0
                ? data.name + " " + data.family
                : "موردی یافت نشد.";

            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    editItem(item) {
      this.currentRole = Object.assign({}, item);
      this.showDialog = true;
      this.isEdit = true;
    },
    removeItem(item) {
      this.$store.commit("SET_DIALOG_ICON", "exclamation");
      this.$store.commit("SET_DIALOG_TYPE", 1);
      this.$store.commit("SET_DIALOG_KEY", item.id);
      this.$store.commit(
        "SET_DIALOG_MESSAGE",
        "آیا مایل به حذف این نقش هستید؟"
      );
      this.$store.commit("SET_DIALOG_SHOW", true);
    },

    applyRequest() {
      var text = "";

      if (this.currentRole.fardId == 0) {
        text = "فرد بایستی انتخاب شود.";
      }
      if (text != "") {
        this.$store.commit("SET_SNACKBAR_TEXT", text);

        return;
      } else {
        this.$store.commit("SET_API_RUNNING", true);
        SaveRole(
          this.currentRole.id,
          this.currentBranch.id,
          this.currentRole.fardId,
          this.currentRole.isActive,
          this.currentRole.role
        )
          .then((response) => {
            const data = response.data;
            this.$store.commit("SET_SNACKBAR_TEXT", data.message);
            this.$store.commit("SET_API_RUNNING", false);
            this.showDialog = false;
            this.GetAllUserRoles();
          })
          .catch((error) => {
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
          });
      }
    },

    /**
     * call remove api if user click on yes
     */
    onCloseDialog(index) {
      if (index != -1) {
        DeleteRole(index)
          .then((response) => {
            const data = response.data;
            this.$store.commit("SET_SNACKBAR_TEXT", data.message);

            if (data.success) {
              this.GetAllUserRoles();
            }
          })

          .catch((error) => {
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
          });
      }
      this.$store.commit("SET_DIALOG_SHOW", false);
    },
  },
};
</script>